export const ClaimDocumentsUploadStatuses = {
  PENDING: 'PENDING',
  COMPLETE: 'COMPLETE',
} as const;

export type ClaimDocumentUploadStatus =
  (typeof ClaimDocumentsUploadStatuses)[keyof typeof ClaimDocumentsUploadStatuses];
